/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Spaces_Add_Users_SuccessInputs */



/**
* | output |
* | --- |
* | "{count} user(s) added successfully." |
*
* @param {Spaces_Add_Users_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_add_users_success = /** @type {((inputs: Spaces_Add_Users_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Add_Users_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Benutzer erfolgreich hinzugefügt.`)
	return /** @type {LocalizedString} */ (`${i?.count} user(s) added successfully.`)
});